import { Link } from "react-router-dom";
import { ArrowRight, Gift } from "lucide-react";

const ReferralCTA = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-r from-primary/5 to-accent/5 border-y border-primary/10">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          {/* Left: Content */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Gift className="w-6 h-6 text-accent" />
              <span className="text-accent font-semibold text-sm uppercase tracking-wider">
                Earn Money Easily
              </span>
            </div>
            
            <h2 className="text-4xl font-bold text-primary mb-4 leading-tight">
              Earn Up to $5,000 Per Referral
            </h2>
            
            <p className="text-lg text-muted-foreground mb-6 leading-relaxed">
              Know a property investor or developer who needs commercial financing? Refer them to Atralend and earn up to $5,000 when their loan funds.
            </p>
            
            <ul className="space-y-3 mb-8">
              <li className="flex items-start gap-3">
                <span className="text-accent font-bold text-lg mt-0.5">✓</span>
                <span className="text-sm text-text">Get a unique referral link instantly</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-accent font-bold text-lg mt-0.5">✓</span>
                <span className="text-sm text-text">Share with friends, colleagues, and network</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-accent font-bold text-lg mt-0.5">✓</span>
                <span className="text-sm text-text">Earn $500–$5,000 when they get funded</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-accent font-bold text-lg mt-0.5">✓</span>
                <span className="text-sm text-text">No limits—earn as much as you can</span>
              </li>
            </ul>
            
            <Link
              to="/referral"
              className="inline-flex items-center gap-2 px-6 py-3 bg-accent hover:bg-accent/90 text-accent-foreground font-semibold rounded-lg transition-colors shadow-lg hover:shadow-xl"
            >
              Get My Referral Link
              <ArrowRight className="w-5 h-5" />
            </Link>
          </div>

          {/* Right: Stats/Highlight */}
          <div className="space-y-6">
            <div className="bg-white rounded-lg p-8 shadow-md border border-primary/10">
              <div className="text-5xl font-bold text-primary mb-2">$5,000</div>
              <p className="text-primary font-semibold">Max earning per referral</p>
              <p className="text-muted-foreground text-sm mt-2">Based on loan size and terms</p>
            </div>

            <div className="bg-white rounded-lg p-8 shadow-md border border-primary/10">
              <div className="text-5xl font-bold text-primary mb-2">48hrs</div>
              <p className="text-primary font-semibold">Fast funding for your referrals</p>
              <p className="text-muted-foreground text-sm mt-2">Commercial loans approved in 48 hours</p>
            </div>

            <div className="bg-white rounded-lg p-8 shadow-md border border-primary/10">
              <div className="text-5xl font-bold text-primary mb-2">∞</div>
              <p className="text-primary font-semibold">Unlimited referrals</p>
              <p className="text-muted-foreground text-sm mt-2">No cap on how much you can earn</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReferralCTA;
